import { fromJS } from 'immutable';

export function request(state) {
    return state.set('imageUpload', {
        status: 'IN_PROGRESS'
    });
}

export function finish(state, { result }) {
    return state.set('imageUpload', {
        status: 'FINISHED',
        result
    });
}

export function error(state) {
    return state.set('imageUpload', {
        status: 'ERROR'
    });
}
